<template>
	<div>
		<div class="d-flex input-container">
			<el-input
				v-bind="$attrs"
				:value="value"
				@input="sendValue"
			></el-input>
			<img :src="location" alt="localizador" class="location">
		</div>
		<slot name="err"></slot>
	</div>
</template>
<script>
function sendValue(val) {
	this.$emit('input', val);
}

function data() {
	return {
		location: '/static/img/icons/location.svg',
	};
}

export default {
	name: 'input-component',
	data,
	inheritAttrs: false,
	methods: {
		sendValue,
	},
	props: {
		value: null,
	},
};
</script>

<style lang="scss" scoped>
	.location {
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// inputComponent.vue?90fc90c8